import React, { Component } from 'react'
import styled from 'styled-components'
import { SearchDiagnosesML } from '@sukiai/gql/app'
import client from '../apollo'
import debounce from 'lodash/debounce'
import ICD10List from './ICD10List'
import search from '../lib/assets/icons/search.svg'
import searchSilver from '../lib/assets/icons/search-silver.svg'
import closeButton from '../lib/assets/icons/closeButton.png'
import leftChevron from '../lib/assets/icons/left-chevron.svg'
import { ICD10_MODAL, LO_STO, RESPONSIVE } from '../lib/constants'
import { Loading } from '@sukiai/components'
import { isAmwellTheme } from '../lib/util'
import loSto from '../config/loSto'

const EmptyState = styled.div`
  padding: 30px;
`

const MoreResultsState = styled.div`
  padding: 5px;
  font-size: 11pt;
  color: #555555;
`

const ResultsState = styled.div`
  padding: 5px;
  font-size: 14pt;
`

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${RESPONSIVE.MODAL_FULL_WIDTH};
  max-width: ${RESPONSIVE.MODAL_LARGE_WIDTH};
  height: 80vh;
  background-color: white;
  box-shadow: 0px 0px 10px rgba(1, 1, 1, 0.2);
  font-size: 15pt;
  * {
    box-sizing: border-box;
  }
`

const ContainerDark = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  overflow: auto;
  width: 600px;
  height: 80vh;
  background-color: #313a42;
  box-shadow: 0px 0px 10px rgba(1, 1, 1, 0.2);
  font-size: 15pt;
  * {
    box-sizing: border-box;
  }
  @media (max-width: 650px) {
    width: calc(500px - 24px);
  }
  .overflow-wrap {
    width: 100%;
    color: #fff;
    padding: 0 28px;
  }

  &::-webkit-scrollbar {
    background-color: #1a1f24;
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgb(45,55,64);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #494c50;
    border-radius: 16px;
    border: 4px solid rgb(45,55,64);
  }

  &::-webkit-scrollbar-button {
    display:none;
  }

`

const SearchIcon = styled.img.attrs({
  src: search
})`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 45px;
  color: red;
  top: 10px;
  display: ${props => (props.isLoading ? 'none' : 'block')};
`

const SearchIconSilver = styled.img.attrs({
  src: searchSilver
})`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 45px;
  color: red;
  top: 10px;
  display: ${props => (props.isLoading ? 'none' : 'block')};
`

const LoadingIcon = styled.div`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 45px;
  top: 10px;
  display: ${props => (props.isLoading ? 'block' : 'none')};
`
const ToolBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #ececec;
  font-size: 16px;
  padding: 40px 25px;
  h2 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: #3b3b3b;
  }
`

const ToolBarDark = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #313a42;
  font-size: 16px;
  border-radius: 12px 12px 0 0;
  padding: 40px 25px;
  h2 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: #fff;
  }
`

const SearchContainer = styled.div`
  width: 100%;
  background: #ececec;
  padding: 0 30px 25px;
  position: relative;
`
const AMWELL_DARK_BG = '#313a42'
const AMWELL_DARK_INPUT = '#39424B'

const SearchContainerDark = styled.div`
  width: 100%;
  background: ${AMWELL_DARK_BG};
  padding: 0 30px 25px;
  position: relative;
`
const SearchBarDark = styled.input`
  width: 100%;
  border-radius: 10px;
  padding: 13px 15px;
  font-size: 16px;
  border: none;
  box-sizing: border-box;
  color: #bec3cc;
  background: ${AMWELL_DARK_INPUT};
  outline: none;
`
const PoweredByText = styled.div`
  font-size: 12px;
  margin-top: 4px;
  color: #888888;
`

const SearchBar = styled.input`
  width: 100%;
  border-radius: 10px;
  padding: 13px 15px;
  font-size: 16px;
  border: 1px solid #d3d3d3;
  box-sizing: border-box;
  color: black;
  outline: none;
`

const ActionSlot = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`

const CloseModalButton = styled.img.attrs({
  src: closeButton
})`
  width: 35px;
  height: 35px;
  &:hover {
    cursor: pointer;
  }
`
const CloseModalButtonDark = styled.div`
  #mdiv {
    width: 25px;
    height: 25px;
    cursor: pointer;
  }
  .mdiv {
    height: 25px;
    width: 2px;
    margin-left: 12px;
    background-color: #fff;
    transform: rotate(45deg);
    Z-index: 1;
  }
  .md {
    height: 25px;
    width: 2px;
    background-color: #fff;
    transform: rotate(90deg);
    Z-index: 2;
  }
`
const BackButton = styled.img.attrs({
  src: leftChevron
})`
  width: 28px;
  height: 28px;
  &:hover {
    cursor: pointer;
  }
`

const OverflowContainer = styled.div`
  overflow: hidden auto;
  width: 100%;
`

class ICDLookupModal extends Component {
  state = {
    searchQuery: '',
    results: [],
    suggestions: [],
    history: [],
    parent: null,
    child: null,
    isLoading: false,
    patientId: null,
    emrEncounterId: null,
    isAmwellDark: isAmwellTheme()
  }

  componentDidMount () {
    const searchQuery = this.props.sectionName.trim()
    if (searchQuery !== '') {
      this.setState({ searchQuery }, this.searchDiagnoses)
    }
  }

  searchDiagnoses = () => {
    const { searchQuery } = this.state
    const { emrEncounterId, patientId } = this.props
    const searchTitle = searchQuery
    const searchDescription = searchQuery // TODO: Will update once backend is implemented
    this.setState({ isLoading: true })

    if (searchQuery.trim() === '') {
      // set to default
      this.setState({
        history: [],
        parent: null,
        child: null,
        results: [],
        suggestions: [],
        isLoading: null
      })

      return
    }

    client
      .query({
        query: SearchDiagnosesML,
        skip: !searchTitle || !searchDescription,
        variables: { searchTitle, searchDescription, patientId, emrEncounterId }
      })
      .then(({ data }) => {
        const suggestions = data.searchDiagnosesML.suggestions
        const results = data.searchDiagnosesML.diagnoses
        // reset history
        const history = []
        const parent = null
        const child = null

        this.setState({
          results,
          suggestions,
          history,
          parent,
          child,
          isLoading: false
        })
      })
  }

  componentWillReceiveProps (nextProps) {
    nextProps.shouldDismiss && this.props.open && nextProps.removeModal()
  }

  onQueryChange = debounce(searchQuery => {
    this.setState({ searchQuery }, this.searchDiagnoses)
  }, 200)

  handleUpLevel = () => {
    // remove current snapshot
    const history = this.state.history.slice(0, -1)
    // get last snapshot
    // if none then go to base level
    const prev = history.length > 0 ? history.slice(-1)[0] : null
    const child = prev ? prev.children : null
    const parent = child ? prev.diagnosis : null
    this.setState({ history, child, parent })
  }

  handleCloseModal = () => {
    const { fromConfirm, goToConfirm } = this.props
    if (fromConfirm) {
      goToConfirm()
    } else {
      this.closeModal()
    }
  }

  closeModal = () => {
    this.props.dismiss() && this.props.removeModal()
  }

  setChild = diagnosisObj => {
    const { children, diagnosis } = diagnosisObj
    const history = [...this.state.history]
    history.push(diagnosisObj)
    this.setState({ child: children, parent: diagnosis, history })
  }

  setCode = async diagnosis => {
    // set code -> showIsLoading?
    // then closeModal
    const { updateDiagnosis, fromConfirm, goToConfirm } = this.props
    await updateDiagnosis(diagnosis, true)
    if (fromConfirm) {
      goToConfirm()
    } else {
      this.closeModal()
    }
  }

  render () {
    const {
      parent,
      child,
      suggestions,
      results,
      searchQuery,
      isLoading,
      isAmwellDark
    } = this.state

    const displayResults = (results.length > 0 || suggestions.length > 0) && !child
    const displayChild = !!child
    const displayEmptyState = suggestions.length === 0 && results.length === 0
    const displayMoreResultsState = results.length > 25
    const isIMOPowered = loSto.get(LO_STO.IS_IMO_POWERED)

    const CloseButton = () => {
      return (
        <CloseModalButtonDark onClick={this.handleCloseModal}>
          <div id='mdiv'>
            <div className='mdiv'>
              <div className='md' />
            </div>
          </div>
        </CloseModalButtonDark>
      )
    }
    if (isAmwellDark) {
      return (
        <ContainerDark onClick={e => e.stopPropagation()}>
          <ToolBarDark>
            <ActionSlot>
              {child && <BackButton onClick={this.handleUpLevel} />}
            </ActionSlot>
            <h2>ICD-10 Code Lookup</h2>
            <CloseButton />
          </ToolBarDark>
          <SearchContainerDark>
            <LoadingIcon isLoading={isLoading}>
              <Loading size='small' />
            </LoadingIcon>
            <SearchIconSilver isLoading={isLoading} />
            <SearchBarDark
              type='text'
              placeholder='Filter by name or code'
              defaultValue={this.props.sectionName}
              onKeyUp={e => this.onQueryChange(e.target.value)}
            />
            {isIMOPowered && <PoweredByText>Powered by IMO® Terminology. © 2023</PoweredByText>}
          </SearchContainerDark>
          <div className='overflow-wrap'>
            <OverflowContainer>
              {displayResults && (
                <>
                  {!!suggestions.length && (
                    <ICD10List
                      type={ICD10_MODAL.DIAGNOSTICS_ML}
                      setChild={this.setChild}
                      setCode={this.setCode}
                      diagnoses={suggestions}
                      searchQuery={searchQuery}
                    />
                  )}

                  <ResultsState>Results</ResultsState>
                  {displayMoreResultsState ? <MoreResultsState>Showing first 25 results. Type more terms to narrow.</MoreResultsState> : null}

                  {!!results.length && (
                    <ICD10List
                      type={ICD10_MODAL.DIAGNOSTICS}
                      setChild={this.setChild}
                      setCode={this.setCode}
                      diagnoses={results}
                      searchQuery={searchQuery}
                    />
                  )}
                </>
              )}

              {displayChild && (
                <ICD10List
                  type={ICD10_MODAL.CHILD}
                  setChild={this.setChild}
                  setCode={this.setCode}
                  diagnoses={child}
                  parent={parent}
                  searchQuery={searchQuery}
                />
              )}

              {displayEmptyState &&
                <EmptyState>Your search <strong>{searchQuery}</strong> did not match any results.</EmptyState>}
            </OverflowContainer>
          </div>
        </ContainerDark>
      )
    }

    return (
      <Container onClick={e => e.stopPropagation()}>
        <ToolBar>
          <ActionSlot>
            {child && <BackButton onClick={this.handleUpLevel} />}
          </ActionSlot>
          <h2>ICD-10 Code Lookup</h2>
          <CloseModalButton onClick={this.handleCloseModal} />
        </ToolBar>
        <SearchContainer>
          <LoadingIcon isLoading={isLoading}>
            <Loading size='small' />
          </LoadingIcon>
          <SearchIcon isLoading={isLoading} />
          <SearchBar
            type='text'
            placeholder='Filter by name or code'
            defaultValue={this.props.sectionName}
            onKeyUp={e => this.onQueryChange(e.target.value)}
          />
          {isIMOPowered && <PoweredByText>Powered by IMO® Terminology. © 2023</PoweredByText>}
        </SearchContainer>
        <OverflowContainer>
          {displayResults && (
            <>
              {!!suggestions.length && (
                <ICD10List
                  type={ICD10_MODAL.DIAGNOSTICS_ML}
                  setChild={this.setChild}
                  setCode={this.setCode}
                  diagnoses={suggestions}
                  searchQuery={searchQuery}
                />
              )}

              <ResultsState>Results</ResultsState>
              {displayMoreResultsState ? <MoreResultsState>Showing first 25 results. Type more terms to narrow.</MoreResultsState> : null}

              {(!!results.length) && (
                <ICD10List
                  type={ICD10_MODAL.DIAGNOSTICS}
                  setChild={this.setChild}
                  setCode={this.setCode}
                  diagnoses={results}
                  searchQuery={searchQuery}
                />
              )}
            </>
          )}

          {displayChild && (
            <ICD10List
              type={ICD10_MODAL.CHILD}
              setChild={this.setChild}
              setCode={this.setCode}
              diagnoses={child}
              parent={parent}
              searchQuery={searchQuery}
            />
          )}

          {displayEmptyState &&
            <EmptyState>Your search <strong>{searchQuery}</strong> did not match any results.</EmptyState>}
        </OverflowContainer>
      </Container>
    )
  }
}

export default ICDLookupModal
